import { createRouter, createWebHistory } from "vue-router";

import routes from "@/router/routes";

import { checkAccessMiddleware } from "./middlewares/checkAccessMiddleware";
import SaveState from "@services/navigation/SaveState.js";
const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: "active",
    linkExactActiveClass: "active",
    routes,
});

router.beforeEach(checkAccessMiddleware);


router.afterEach((to, from) => {
    if (to.name !== 'login' || from.name !== 'login') {
        SaveState.saveState(to, 'forward');
    }
});
export default router;
